import { render, staticRenderFns } from "./wxmpUserList.vue?vue&type=template&id=1c5c5402&scoped=true&"
import script from "./wxmpUserList.vue?vue&type=script&lang=js&"
export * from "./wxmpUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c5402",
  null
  
)

export default component.exports